import { useMediaQuery, useTheme } from "@mui/material";
export const useScreenWidth = () => {
    const theme = useTheme();
    const isMinTablet = useMediaQuery(theme.breakpoints.up(theme.breakpoints.values.tablet), { noSsr: true });
    const isMinDesktop = useMediaQuery(theme.breakpoints.up(theme.breakpoints.values.desktop), { noSsr: true });
    const isMinLargeDesktop = useMediaQuery(theme.breakpoints.up(theme.breakpoints.values.xl), { noSsr: true });
    return {
        isMaxPhone: !isMinTablet,
        isMinTablet,
        isMaxTablet: !isMinDesktop,
        isMinDesktop,
        isMaxDesktop: !isMinLargeDesktop,
        isMinLargeDesktop,
    };
};
//# sourceMappingURL=useScreenWidth.js.map